
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import ajax from './assets/js/ajax'
import Vuex from 'vuex'//引入vuex
import  item  from './service/item'

Vue.use(Vuex);
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.use(ViewUI);
import VueResource from 'vue-resource'
Vue.use(VueResource)
import axios from 'axios'
import Qs from 'qs'
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
import 'lib-flexible'
import 'vant/lib/index.css';
import service from './service/service'
Vue.prototype.$service = service
import {codetoken} from './service/fetch'

import aaa from './service/aaa'
Vue.prototype.$aaa = aaa
import Spin from 'view-design';
Vue.prototype.$Spin = Spin
Vue.prototype.$item = item
Vue.use(Vant);
Vue.config.productionTip = false
//
//localStorage.setItem('url', 'http://39.98.39.49:1889/')
localStorage.setItem('url', 'http://wx.colossusgroup.com:1889/') //2022-6-29
/* eslint-disable no-new */
console.log('好的')
console.log(window.location)
const self = this
let base = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=';
let redirectURL = encodeURI((window.location.href).split('&code')[0]);//获取地址
// console.log()
console.log(redirectURL)

// const baseurl = "http://kdc.colossusgroup.com"
//const baseurl = "http://clone.tolinksoft.com"  LHJ 2022-3-18
const baseurl = "http://wx.colossusgroup.com"
// 解析url参数并获取code
function getUrlParam(name) {   //name为要获取的参数名
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var rrr = decodeURIComponent(window.location.search);
  var r = rrr.substr(1).match(reg);
  if(r != null) return unescape(r[2]);
  console.log('qqq')
  return null;
}
// 请求微信服务器获取code 方法
function getUserCode() {
  redirectURL = encodeURI((baseurl + window.location.pathname + window.location.search).split('&code')[0]);//获取地址
  let state;
  let surl;
  let reserveUrl;
  let appid = "wxb90973aace79a8d6";
  let scope = "snsapi_base";
  window.location.href =base + appid +'&redirect_uri='+ redirectURL +'&response_type=code&scope='+ scope +'#wechat_redirect';
}

// 路由变化时

 router.beforeEach((to, from, next) => {
  // ;
  localStorage.setItem('zt', '0');// 0 是个人  1是企业
  if (to.meta.title) {
    document.title = to.meta.title;
    //里程碑标题
        if (to.name == 'lcb'){
          let fullPath = to.fullPath
          console.log(fullPath)
          let pageLang = 0
          let urlParams = fullPath.split('?')
          if(urlParams.length > 1){
            urlParams = window.location.href.split('?')[1]
            let paramsArr = new URLSearchParams('?'+urlParams)
            pageLang = parseInt(paramsArr.get('lang'))
          }
          if (pageLang === 1)document.title = 'Milestone'
          if (pageLang === 2)document.title = 'Основные этапы'
        }
  }
  console.log("to 路径：");
  console.log(to);
  if(to.path == '/zqhdjg'){
    const code_c = getUrlParam('code');//获取url 上面的code
    if(!code_c){
      sessionStorage.setItem("qdjg",to.query.type);
    }
    console.log('zzzzzzzzzzzzzzzzzzzzz',to.path);
  }

  if(to.path == '/lcb' || to.path == '/temporary' || to.path == '/detail' || to.path == '/attachment'){
    console.log(to.path);
    next();
  }
  // else if(to.path == "/zqhdbm"){
  //     const code = getUrlParam('code');//获取url 上面的code
  //     // 还未完成微信授权
  //     if (!code) {//假如没code
  //       let appid_cust = "wxb90973aace79a8d6";
  //       let scope_cust = "snsapi_base";
  //       let base_url=encodeURI(('http://wx.colossusgroup.com' + to.path + window.location.search).split('&code')[0]);
  //       window.location.href ='https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid_cust +'&redirect_uri='+ redirectURL +'&response_type=code&scope='+ scope_cust +'#wechat_redirect';
  //     }
  //     if (code) {
  //       const {errr,data} =  service.home.GetUserOpenIdByCode({
  //         code:code
  //       }).then(res=>{
  //         console.log('臧',res)
  //         localStorage.setItem('openidcust', res.data.objectEntity.openid)
  //         next();
  //       })
  //     }
  // }
  else {

    if(to.path == '/' || to.path == '/qymob'|| to.path == '/mobg'|| to.path == '/grmob'){

    } else {
      sessionStorage.setItem('rto', to.path);
    }
    console.log("form 路径：");
    console.log(from);

    //读取sessionStorage的user
    let user = JSON.parse(localStorage.getItem('user'));
    // 已登录
    if (user) {
      if(user == '777'){
      } else {
        sessionStorage.setItem('udata', localStorage.getItem('udata'))
        next();//释放路由 如果已经登录
      }

    }
    // 未登录 且不是在测试环境下
    let off = sessionStorage.getItem('off')
    if ((!user||user=='777')&& !off && document.domain != "127.0.0.1") {
      const code = getUrlParam('code');//获取url 上面的code
      // 还未完成微信授权

      if (!code) {//假如没code
        getUserCode();//请求微信服务器获取code
      }

      // 已完成微信授权 假如已经获取到了code
      if (code) {
        let r = 'https://api.weixin.qq.com/sns/oauth2/access_token?appid=wxb90973aace79a8d6&secret=976c1e9acd9dec100719b412b5041e7a&code='+code+'&grant_type=authorization_code'
        console.log(r)
        console.log(code)

        let userInfo = '';
        console.log(code)
        const {errr,data} =  service.home.GetUserOpenIdByCode({
          code:code
        }).then(res=>{
          console.log('code授权接口')
          console.log(res)
          console.log(res.data.status)

          if(res.data.status == '500'){
            // sessionStorage.setItem('udata', res.data.objectEntity.objectEntity)
            localStorage.setItem('openid', res.data.objectEntity.openid)
            sessionStorage.setItem('off', '11111')
            localStorage.setItem('user', '777');
            if(sessionStorage.getItem('rto') == "/zqhdbm" || sessionStorage.getItem('rto') == "/zqhdqmcx" || sessionStorage.getItem('rto') == "/zqhdjg" || sessionStorage.getItem('rto') == "/zqhdqr" || sessionStorage.getItem('rto') == "/zqhdgrxx" || sessionStorage.getItem('rto') == "/zhgzhfk" || sessionStorage.getItem('rto') == "/rzsqd1" || sessionStorage.getItem('rto') == "/rzsqd2"){
                next({path:sessionStorage.getItem('rto')})
            }else{
              next({path:'/'} )
            }
            //next({path:'/'} )
            // self.router.replace({name:'mob'} )
          } else {

            console.log(res.data.objectEntity)
            if(res.data.objectEntity.objectEntity){


            delete res.data.objectEntity.objectEntity.etC_JTCYEntry
            delete res.data.objectEntity.objectEntity.etC_WWZ_JTCYEntry
            delete res.data.objectEntity.objectEntity.etC_WWZ_RYYZZEntry
            delete res.data.objectEntity.objectEntity.etC_WWZ_ZC_FGZJLEntity
            delete res.data.objectEntity.objectEntity.fjtcyEntity
            delete res.data.objectEntity.objectEntity.fworkEntity
            delete res.data.objectEntity.objectEntity.fryyzzEntity
            delete res.data.objectEntity.objectEntity.etC_WORKEntry
            delete res.data.objectEntity.objectEntity.etC_RYYZZEntry
          }
            console.log('11')
            console.log(res.data.objectEntity.objectEntity)
            var a = res.data.objectEntity

            sessionStorage.setItem('udata', JSON.stringify(a))
            localStorage.setItem('udata', JSON.stringify(a))
            localStorage.setItem('openid', res.data.objectEntity.openid)
            localStorage.setItem('user', '666');
            codetoken()
            next({path:sessionStorage.getItem('rto')} )
          }
        })
      }
    }else{
      codetoken()
      next();
    }
  }

});


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js